// Sticky notice shown when the browser reports it is offline or when an API
// call gives up after retrying. Hides itself once a request succeeds again or
// the browser comes back online.
import { useEffect, useState } from 'react';
import { setNetworkErrorHandler } from '../../services/api';
import styles from './OfflineBanner.module.css';

export default function OfflineBanner() {
    const [reason, setReason] = useState(() => (typeof navigator !== 'undefined' && navigator.onLine === false ? 'offline' : null));

    useEffect(() => {
        const goOffline = () => setReason('offline');
        const goOnline = () => setReason(null);
        window.addEventListener('offline', goOffline);
        window.addEventListener('online', goOnline);
        setNetworkErrorHandler(() => setReason('unreachable'));
        return () => {
            window.removeEventListener('offline', goOffline);
            window.removeEventListener('online', goOnline);
            setNetworkErrorHandler(null);
        };
    }, []);

    if (!reason) return null;

    return (
        <div className={styles.banner} role="status" aria-live="polite">
            <span aria-hidden="true">⚠️</span>
            <span>
                {reason === 'offline'
                    ? "You're offline. Check your connection — we'll pick up where you left off."
                    : "We couldn't reach Aluvo. Check your connection and try again."}
            </span>
            <button type="button" className={styles.dismiss} onClick={() => setReason(null)} aria-label="Dismiss">✕</button>
        </div>
    );
}
